// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer-p-0yPNhC","foot_link":"foot_link-23CIZRQO","list":"list-gvA-4u-l","link":"link-2EdYwGw4","copyright":"copyright-3FwG5Y9A"};